import React from 'react';
class ColorBtn extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            light: false, 
        };

    }

    render() {
        document.body.style.backgroundColor = this.state.background;
        let e = document.getElementsByName("text");
        for (let x = 0; x < e.length; x++) {
            e[x].style.color = this.state.light? "white":"black";
        }
        return (
            <button type="button" className={
                !this.state.light?"btn btn-dark":"btn btn-light"
            } onClick={() => this.setState({light: !this.state.light, background: this.state.light?"#f6f7f8":"#343a40"})}>
                {!this.state.light?"Dark Mode":"Light Mode"}
            </button>
        );
    }

}

export default ColorBtn;